import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { handleGetTags, setSelectedTag } from 'store/reducers/outlet';
import { uniqueID } from 'utils/constants';
import { encodeValue, isEmptyData } from 'utils/helper';
import { LoaderIcon } from 'utils/svg';

const Tags = () => {
	const dispatch = useDispatch();
	const { details: outlet, tags, selectedTag, isLoadingTags } = useSelector((store) => store.outlet);

	const handleSelectedTag = (tag = null) => {
		dispatch(
			setSelectedTag(tag),
		);
	};

	useEffect(() => {
		if (isEmptyData(outlet?.storeID)) return;
		dispatch(handleGetTags({ uniqueID, storeID: encodeValue(outlet?.storeID) }));
	}, [outlet?.storeID]);

	if (isLoadingTags) {
		return (
			<div className='py-1.5 px-3 w-full flex justify-center'>
				<LoaderIcon />
			</div>
		);
	}
	return (
		<div className='w-full my-2'>
			<div className='grid grid-flow-col auto-cols-max overflow-x-auto snap-x snap-mandatory scroll-smooth scroll-px-4 gap-2 scrollbar-hide'>
				{Array.isArray(tags) ? tags.map((item, index) => {
					return (
						<div
							key={index}
							className={`snap-start cursor-pointer rounded-full bg-gray-100 px-3 py-1.5 text-gray-500 ${selectedTag?.catSlug === item?.catSlug && '!bg-[var(--rose-violet-opacity)] !text-[var(--rose-violet)]'}`}
							onClick={() => handleSelectedTag(item)}>
							<span className='text-center text-nowrap text-xs'>{item?.categoryName || item?.pro_cate_name}</span>
						</div>
					);
				}) : null}
			</div>
		</div>
	);
};

export default Tags;
